<template>
    <div :class="['deals-status', getModify(statusId)]">
        <div class="deals-status__icon">
            <component :is="getIcon(statusId)" />
        </div>
        <div class="deals-status__text">
            {{ name }}
        </div>
    </div>
</template>

<script>
import IconProcess from '@/blocks/DealsBlock/DealsStatus/Icons/IconProcess';
import IconSuccess from '@/blocks/DealsBlock/DealsStatus/Icons/IconSuccess';
import {DEALS_STATUSES} from '@/helpers/constants';

export default {
    name: 'DealsStatus',

    components: {
        IconProcess,
        IconSuccess
    },

    props: {
        name    : String, // название
        statusId: [String, Number]  // id статуса
    },

    methods: {
        getModify(id) {
            const status = DEALS_STATUSES.find((item) => item.id?.toLowerCase() === id?.toLowerCase());

            if (!status) {
                return 'deals-status_theme_process';
            }

            return status.success ? 'deals-status_theme_success' : 'deals-status_theme_process';
        },

        getIcon(id) {
            const status = DEALS_STATUSES.find((item) => item.id?.toLowerCase() === id?.toLowerCase());

            if (!status) {
                return 'IconProcess';
            }

            return status.success ? 'IconSuccess' : 'IconProcess';
        }
    }
};
</script>

<style lang="scss">
@import "DealsStatus";
</style>
